import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgBlocked = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" d="M14.9 2.421 3.269 15.511A1.454 1.454 0 1 1 1.1 13.58L12.731.49A1.454 1.454 0 1 1 14.9 2.421z" /></svg>;
const ForwardRef = forwardRef(SvgBlocked);
export default ForwardRef;